import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
`;

export const TagsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    min-height: 24px;
`;

export const Tag = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 8px;
    background-color: var(--color-gray-100, #f3f4f6);
    border: 1px solid var(--color-gray-200, #e5e7eb);
    border-radius: 6px;
    font-size: 13px;
    color: var(--color-gray-700, #374151);
    max-width: 100%;
    word-break: break-all;

    &[data-disabled='true'] {
        opacity: 0.5;
    }
`;

export const TagText = styled.span`
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const RemoveButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    padding: 0;
    border: none;
    background: transparent;
    color: var(--color-gray-400, #9ca3af);
    cursor: pointer;
    border-radius: 4px;
    flex-shrink: 0;
    transition:
        color 0.15s ease,
        background-color 0.15s ease;

    &:hover {
        color: var(--color-gray-600, #4b5563);
        background-color: var(--color-gray-200, #e5e7eb);
    }

    &:focus {
        outline: none;
        color: var(--color-gray-600, #4b5563);
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }
`;

export const InputWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
`;

export const HintText = styled.span`
    font-size: 11px;
    color: var(--color-gray-400, #9ca3af);
    margin-top: -4px;
`;
